import { useEffect } from "react";
import { Authenticator, useAuthenticator, View } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { useNavigate, useLocation } from "react-router";
//import { makeStyles } from "tss-react/mui";
import {
  Box,
  Card,
  Grid,
  //Theme,
  Typography,
  //useTheme,
} from "@mui/material";
import { Link as Hyperlink } from "@mui/material";

//const useStyles = makeStyles()((theme: Theme) => ({}));

export function LoginPage() {
  //const { classes } = useStyles();
  //const theme = useTheme();
  const { route } = useAuthenticator((context) => [context.route]);
  const location = useLocation();
  const navigate = useNavigate();
  let from = location.state?.from?.pathname || "/";
  useEffect(() => {
    if (route === "authenticated") {
      navigate(from, { replace: true });
    }
  }, [route, from, navigate]);

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        component="div"
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={4}
          xl={4}
          padding={2}
          textAlign="center"
          component="div"
        >
          <Card>
          &nbsp;<br />
            <Typography variant="h5">LLM as a Service</Typography>
            <Typography variant="h6">
              Add LLM features to your application in minutes
            </Typography>
            <Typography variant="body2">
              Please sign-in or register to access access the administration console.
            </Typography>
            <br />
            <Box
              sx={{
                display: { xs: "none", sm: "none", md: "block", lg: "block" },
              }}
              component="div"
            >
              <img src="/logo.png" width="200px" alt="LLMAsAService.io logo" />
            </Box>
            <Box sx={{ p: 1 }}>
              <Typography variant="body2">
                LlmAsAService.io is a product by CASEy, Inc.
              </Typography>
              <Hyperlink href="https://www.llmasaservice.io/">
                Company
              </Hyperlink>
              &nbsp;|&nbsp;
              <Hyperlink href="https://www.llmasaservice.io/privacy/">
                Privacy policy
              </Hyperlink>
              &nbsp;|&nbsp;
              <Hyperlink href="https://www.llmasaservice.io/terms-of-service/">
                Terms of service
              </Hyperlink>
            </Box>
          </Card>
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={4}
          padding={2}
          component="main"
        >
          <View className="auth-wrapper">
            <Authenticator></Authenticator>
          </View>
        </Grid>
      </Grid>
    </>
  );
}
//